
    import { Component, Vue } from 'vue-property-decorator';
    import { APP_CONFIG } from '@/config/app-config';

    @Component
    export default class CustomerInfo extends Vue {
        get customerInfo() {
            return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
        }
    }
